"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SocialMediaIcon = require("./SocialMediaIcon");
Object.keys(_SocialMediaIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialMediaIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialMediaIcon[key];
    }
  });
});
